import React, { useState, useEffect, useRef } from "react";
import "./accountSetting.scss";
import {
  CallIcon,
  DeleteIcon,
  EditIcon,
  EmailIcon,
  LocationIcon,
  PasswordIcon,
  ClockIcon,
  SheildIcon,
  DollorIcon,
  ServicesIcon,
  UserIcon,
  NotificationSettingIcon,
} from "../../../components/Icons";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ReactDatePicker from "react-datepicker";
import StarRating from "../../../components/rating/StarRating";
import {
  provider_getProfile,
  updateAvailability,
  updateAvailabilityTiming,
  deleteService,
  updateProfile,
  updateNotificationSettingsProvider,
  sendReferralEmail,
  ChangePassword,
  fetchBankDetailsStatus,
  addAccountDetail,
  updateAccountDetail,
  serviceImageUpload,
  serviceImageRemove,
  UpdateMarketingEmail,
  logOut,
  updateJobBufferSettings,
  deleteProfileById,
} from "../../../services/auth.service";
import {
  convertHourToDate,
  defaultShifts,
  getFullName,
  getImageNameFromUrl,
} from "../../../utils/common";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getService } from "../../../services/auth.service";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY, toast_success } from "../../../config/Constant";

import { Container } from "react-bootstrap";
import { clearUserLocation, setLoader } from "../../../slice/commonSlice";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { useSelector, useDispatch } from "react-redux";
import { selectUser, logout } from "../../../slice/authSlice";
import { encryptData, decryptData } from "../../../utils/encryptDecrypt";
import ImageUpload from "./ImageUpload";
import ConfirmModal from "../../../modals/confirmModal/ConfirmModal";
import DeleteModal from "../../../modals/deleteModel/DeleteModal";
import InfoIcon from "../../../assets/images/info-icon2.png";

import Chip from "@mui/material/Chip";
import NoDogs from "../../../assets/images/nodogs.jpg";
import Allergy from "../../../assets/images/allergy.png";
import Disability from "../../../assets/images/disability.png";
import { Avatar } from "@mui/material";
import MuiAutocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const AccountSetting = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector(selectUser);
  const [confirmDeleteProfile, setConfirmDeleteProfile] = useState(false);
  const [isToggled, setIsToggled] = useState(true);
  const [services, setServices] = useState();
  const [availability, setAvailability] = useState();

  const [providerData, setProviderData] = useState({});
  const [serviceName, setsetServiceName] = useState([]);
  const [image1, setImage1] = useState(null);

  const [BufferHour, setBufferHour] = useState("");

  const [notificationSettings, setNotificationSettings] = useState({});
  const [email, setEmail] = useState("");
  const [changePassword, setChangePassword] = useState({});
  const [resetKey, setResetKey] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [errors, setErrors] = useState({}); //Add state variables for form data and validation errors.
  const [serviceImages, setServiceImages] = useState([]);
  const [formData, setFormData] = useState({
    accountNumber: "",
    accountHolderName: "",
    branchName: "",
    bankTableID: "",
  });
  const [isEditMode, setIsEditMode] = useState(true);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [serviceId, setServiceId] = useState(null);
  const [editMarketing, setEditMarketing] = useState(false);

  const [alignment, setAlignment] = useState(user.userType);
  const [proRating, setProRating] = useState();
  const [resetImages, setResetImages] = useState(false);
  const [confirmStatus, setConfirmStatus] = useState(false);

  const [marketingEmail, setMarketingEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const [days, setDays] = useState([]);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [badges, setBadges] = useState([]);

  const [childSafetyCertificate, setChildSafetyCertificate] = useState(null);
  const [policeVerificationCertificate, setPoliceVerificationCertificate] =
    useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [policeVerificationPreview, setPoliceVerificationPreview] =
    useState(null);

  // Define the chip data including labels and avatar sources
  // Define the avatar sources for each badge
  const avatarSources = {
    "No Dogs": NoDogs,
    Allergies: Allergy,
    Sunflower: Disability,
  };

  // Define the chip data including labels and avatar sources
  const chipData = [
    {
      key: 5,
      label: "No Dogs",
      avatarSrc: avatarSources["No Dogs"],
      value: "nodogs",
    },
    {
      key: 6,
      label: "Allergies",
      avatarSrc: avatarSources["Allergies"],
      value: "allergy",
    },
    {
      key: 7,
      label: "Sunflower",
      avatarSrc: avatarSources["Sunflower"],
      value: "sunflower",
    },
  ];

  let displayBadges = [
    {
      key: 5,
      label: "No Dogs",
      avatarSrc: avatarSources["No Dogs"],
      value: "nodogs",
    },
    {
      key: 6,
      label: "Allergies",
      avatarSrc: avatarSources["Allergies"],
      value: "allergy",
    },
    {
      key: 7,
      label: "Sunflower",
      avatarSrc: avatarSources["Sunflower"],
      value: "sunflower",
    },
    {
      key: 8,
      label: "SCARS",
      avatarSrc: avatarSources["Sunflower"],
      value: "scars",
    },
    {
      key: 9,
      label: "Police Background",
      avatarSrc: avatarSources["Sunflower"],
      value: "police background",
    },
  ];

  const handleChange = (event, newValue) => {
    setSelectedOptions(newValue);
  };

  //banks
  const banks = [
    {
      value: "1",
      name: "HSBC BANK BERMUDA LIMITED",
      country: "Bermuda",
      type: "Commercial Bank",
    },
    {
      value: "2",
      name: "BANK OF NT BUTTERFIELD AND SON LTD",
      country: "Bermuda",
      type: "Banking and Financial Services",
    },
    {
      value: "3",
      name: "BERMUDA COMMERCIAL BANK LTD",
      country: "Bermuda",
      type: "Commercial Bank",
    },
    {
      value: "4",
      name: "CLARIEN BANK LTD",
      country: "Bermuda",
      type: "Commercial Bank",
    },
  ];

  const handleToggleDay = (index) => {
    const newDays = [...days];
    newDays[index].available = !newDays[index].available;
    setDays(newDays);
  };

  const handleTimeChange = (time, index, type) => {
    const newDays = [...days];
    newDays[index][type] = time;
    // Add validation message
    if (
      type === "startTime" &&
      newDays[index].endTime &&
      time >= newDays[index].endTime
    ) {
      toast.warning("Start time should be less than end time.", {
        position: toast.POSITION.TOP_CENTER,
      });

      // toast_warning("Start time should be less than end time.");
      return;
    }

    if (
      type === "endTime" &&
      newDays[index].startTime &&
      time <= newDays[index].startTime
    ) {
      toast.warning("End time should be greater than start time.", {
        position: toast.POSITION.TOP_CENTER,
      });

      // toast_warning("Start time should be less than end time.");
      return;
    }
    setDays(newDays);
  };

  const handleScheduleSubmit = async () => {
    try {
      await dispatch(setLoader(true));
      const updatedShifts = days.map((day) => ({
        dayOfWeek: day.dayOfWeek,
        available: day.available,
        _id: day._id,
        // Convert startTime and endTime Date objects to hours using getHours()
        startTime: day.startTime ? new Date(day.startTime).getHours() : null,
        endTime: day.endTime ? new Date(day.endTime).getHours() : null,
      }));
      const response = await updateAvailabilityTiming(updatedShifts);
      await dispatch(setLoader(false));
      if (response?.data?.status === true) {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        fetchProfileData();
      } else {
        toast.warning(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      await dispatch(setLoader(false));
    }
  };

  const transformShiftsForState = (shiftsFromBackend) => {
    return defaultShifts.map((defaultShift) => {
      const foundShift = shiftsFromBackend.find(
        (s) => s.dayOfWeek === defaultShift.dayOfWeek
      );

      if (foundShift) {
        return {
          ...foundShift,
          startTime: foundShift.startTime
            ? convertHourToDate(foundShift.startTime, new Date())
            : null,
          endTime: foundShift.endTime
            ? convertHourToDate(foundShift.endTime, new Date())
            : null,
        };
      }
      return defaultShift;
    });
  };

  const handleAlignment = async (event, newAlignment) => {
    const paylaod = {
      deviceId: "deedid",
    };

    localStorage.setItem("accessToken", "");
    await logOut(paylaod);
    dispatch(clearUserLocation());
    dispatch(logout());
    // setShow(false);

    navigate("/?registerModal=true");
  };

  const handleConfirm = (status) => {
    if (status) {
      handleDeleteService(deleteIndex, serviceId);
    }
    setConfirmStatus(false);
  };
  const handleDeleteServiceConfirm = (index, serviceId) => {
    setServiceId(serviceId);
    setDeleteIndex(index);
    setConfirmStatus(true);
  };

  const autocompleteRef = useRef(null);
  const libraries = ["places"];
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const handlePlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef?.current?.getPlace();
      if (place && place.formatted_address) {
        setProviderData((prev) => ({
          ...prev,
          location: place?.formatted_address,
        }));
      }
    }
  };

  // Function to toggle the state
  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const fetchProfileData = async () => {
    try {
      await dispatch(setLoader(true));
      const response = await provider_getProfile();

      setProRating(response?.data?.provider?.ratingProvider);

      setServices(response.data.services);

      let currentDate = new Date();
      setDays(transformShiftsForState(response?.data?.provider?.shifts));
      let datestart = currentDate.setHours(
        response?.data?.provider?.shiftStartTime,
        0,
        0,
        0
      );
      let dateend = currentDate.setHours(
        response?.data?.provider?.shiftEndTime,
        0,
        0,
        0
      );
      setAvailability(response?.data?.provider?.isAvailable);
      setMarketingEmail(response?.data?.provider?.marketingEmail);
      setSelectedOptions(
        chipData.filter((chip) =>
          response?.data?.provider?.badges.includes(chip.label)
        )
      );
      setBadges(
        displayBadges?.filter((chip) =>
          response?.data?.badges.includes(chip.label)
        )
      );

      let objs = {
        profilePic: response?.data?.provider?.profilePic,
        name:
          response?.data?.provider?.firstName +
          " " +
          response?.data?.provider?.lastName,
        firstName: response?.data?.provider?.firstName,
        lastName: response?.data?.provider?.lastName,
        email: response?.data?.provider?.email,
        phone: response?.data?.provider?.phone,
        bio: response?.data?.provider?.bio,
        location: response?.data?.provider?.location,
        policyText: response?.data?.policyText,
        cancellationPolicy:
          response?.data?.policyText ===
          "Cancel before 48 hours at no charge (Strict)"
            ? 48
            : response?.data?.policyText ===
              "Cancel before 12 hours at no charge (Moderate)"
            ? 12
            : response?.data?.policyText ===
              "Cancel anytime before the job has started at no charge (Flexible)"
            ? 0
            : "",

        policy: response?.data?.policyText,

        services: response?.data?.services[0]?.serviceId,
        services_rate: response?.data?.services[0]?.rate,

        shiftStartTime: response?.data?.provider?.shiftStartTime,
        shiftEndTime: response?.data?.provider?.shiftEndTime,
        showStartTime: new Date(datestart),
        showEndTime: new Date(dateend),
        ratingProvider: response?.data?.provider?.ratingProvider,
        childSafetyCertificate:
          response?.data?.provider?.childSafetyCertificate,
        policeVerificationCertificate:
          response?.data?.provider?.policeVerificationCertificate,
      };
      setProviderData(objs);
      setBufferHour(response?.data?.provider?.jobBufferHour);

      let notificationData = {
        providerNotificationJob:
          response?.data?.provider?.providerNotificationJob,
        providerNotificationRating:
          response?.data?.provider?.providerNotificationRating,
        providerNotificationChat:
          response?.data?.provider?.providerNotificationChat,
        providerNotificationPayment:
          response?.data?.provider?.providerNotificationPayment,
        // providerNotificationDispute:response?.data?.provider?.providerNotificationDispute,
      };
      setNotificationSettings(notificationData);

      // Set formData
      setFormData({
        accountNumber: response.data.bankDetails.accountNumber,
        accountHolderName: response.data.bankDetails.accountHolderName,
        // ifscCode: response.data.bankDetails.ifscCode,
        branchName: findBranchName(response?.data?.bankDetails?.branchName),
        bankTableID: response.data.bankDetails._id,
      });
      if (response.data.bankDetails._id) {
        setIsEditMode(false);
      }

      // setLoading(false);
      await dispatch(setLoader(false));
    } catch (error) {
      // setLoading(false);
      await dispatch(setLoader(false));
    }
  };

  const fetchService = async () => {
    const data = await getService();
    setsetServiceName(data.data.services);
  };

  useEffect(() => {
    fetchProfileData();
    fetchService();
  }, []);

  const handleSwitchChange = async (value) => {
    const requestBody = {
      isAvailable: value, // Toggle the current state
    };
    try {
      await dispatch(setLoader(true));
      const bankResponse = await fetchBankDetailsStatus();
      if (bankResponse?.data?.status || user?.marketingEmail !== null) {
        const response = await updateAvailability(requestBody);

        setAvailability((prevChecked) => !prevChecked);
        if (response?.data?.status === true) {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          fetchProfileData();
          props.fetchProfileData();
        } else {
          toast.warning(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } else {
        toast.warning(bankResponse?.data?.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
      await dispatch(setLoader(false));
    } catch (error) {
      console.error("Error updating availability:", error);
      await dispatch(setLoader(false));
    }
  };

  // Helper function to find branch name based on bank name
  const findBranchName = (bankName) => {
    switch (bankName) {
      case "HSBC BANK BERMUDA LIMITED":
        return "1"; // Replace with actual branch name
      case "BANK OF NT BUTTERFIELD AND SON LTD":
        return "2"; // Replace with actual branch name
      // Add more cases as needed for other banks
      case "BERMUDA COMMERCIAL BANK LTD":
        return "3";
      case "CLARIEN BANK LTD":
        return "4";
      default:
        return "1"; // Default value if no match is found
    }
  };

  const findBankName = (branchName) => {
    switch (branchName) {
      case "1":
        return "HSBC BANK BERMUDA LIMITED";
      case "2":
        return "BANK OF NT BUTTERFIELD AND SON LTD";
      case "3":
        return "BERMUDA COMMERCIAL BANK LTD";
      case "4":
        return "CLARIEN BANK LTD";
      default:
        return "HSBC BANK BERMUDA LIMITED"; // Default value if no match is found
    }
  };

  const handleAddService = () => {
    setServices([
      ...services,
      {
        _id: "",
        serviceId: "",
        rate: 0,
        images: [],
      },
    ]);
  };

  const handleServiceImages = (index, images) => {
    setServiceImages((prevImages) => {
      const updatedImages = [...prevImages];
      updatedImages[index] = images;
      return updatedImages;
    });
  };

  const submitServiceImg = async (index, services) => {
    if (!serviceImages[index]) {
      toast.error("No images selected!", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    await dispatch(setLoader(true));

    const formdata = new FormData();
    serviceImages[index].forEach((image) => {
      formdata.append(`serviceImages`, image);
    });

    try {
      const uploadImg = await serviceImageUpload(formdata);
      await dispatch(setLoader(false));

      if (uploadImg?.data?.status) {
        setServices((prevServices) => {
          const updatedServices = [...prevServices];
          const serviceToUpdate = { ...updatedServices[index] };
          serviceToUpdate.images = uploadImg.data.uploadedImages;

          // If you want to add all uploaded images to the existing images array:
          if (
            prevServices[index].images &&
            Array.isArray(prevServices[index].images)
          ) {
            prevServices[index].images.forEach((image) => {
              serviceToUpdate.images.push(image);
            });
          }

          updatedServices[index] = serviceToUpdate;
          handleUpdateProfileimg(updatedServices);
          setServiceImages([]);

          return updatedServices;
        });
      } else {
        toast.error("Unable to upload images!", {
          position: toast.POSITION.TOP_CENTER,
        });
        await dispatch(setLoader(false));
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error uploading images:", error);
    }
  };

  const removeImg = async (imageUrl, index) => {
    let imageName = getImageNameFromUrl(imageUrl); // Extract image name
    await serviceImageRemove({ imageNames: [imageName] });

    setServices((prevServices) => {
      const updatedServices = [...prevServices];
      const serviceToUpdate = { ...updatedServices[index] };

      // Remove the image from serviceToUpdate.images array
      serviceToUpdate.images = serviceToUpdate.images.filter(
        (img) => getImageNameFromUrl(img) !== imageName // Compare by name
      );

      updatedServices[index] = serviceToUpdate;
      handleUpdateProfileimg(updatedServices);
      setServiceImages([]);
      return updatedServices;
    });
  };

  const handleServiceChange = (index, key, value) => {
    setServices((prevServices) => {
      const updatedServices = [...prevServices];
      const serviceToUpdate = { ...updatedServices[index] };

      if (key === "serviceId") {
        // Handle serviceId change
        serviceToUpdate[key] = value;
      } else if (key === "rate") {
        // Handle rate change
        serviceToUpdate[key] = value;
      }

      updatedServices[index] = serviceToUpdate;
      return updatedServices;
    });
  };

  const handleDeleteService = async (index, serviceId) => {
    const updatedServices = [...services];
    updatedServices.splice(index, 1);

    setServices(updatedServices);
    const idToDelete = [{ _id: serviceId }];
    await dispatch(setLoader(true));
    try {
      const result = await deleteService(idToDelete);
      if (result?.data?.status) {
        toast.success("Service deleted successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        setServiceId(null);
        setDeleteIndex(null);
        await dispatch(setLoader(false));
        fetchProfileData();
        props.fetchProfileData();
      } else {
        toast.error("Unable to delete service", {
          position: toast.POSITION.TOP_CENTER,
        });
        await dispatch(setLoader(false));
        setServiceId(null);
        setDeleteIndex(null);
      }
    } catch (err) {
      console.error(err);
      await dispatch(setLoader(false));
      setServiceId(null);
      setDeleteIndex(null);
    }
  };

  const handleFileChange = (e) => {
    setProviderData((previous) => ({
      ...previous,
      profilePic: e.target.files[0],
    }));

    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage1(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;

    setProviderData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Call addAccountDetail API

    try {
      if (validateForm()) {
        const encryptedAccountNumber = encryptData(formData.accountNumber);
        const modifiedFormData = {
          ...formData,
          accountNumber: encryptedAccountNumber,
          branchName: findBankName(formData.branchName),
        };
        const response = await addAccountDetail(modifiedFormData);

        setIsEditMode(false); // Disable editing after submission

        if (response?.data?.status === true) {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          fetchProfileData();
          props.fetchProfileData();
        } else {
          toast.warning(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const managEedit = async () => {
    if (!isEditMode) {
      setIsEditMode(true);
    } else {
      try {
        if (validateForm()) {
          await dispatch(setLoader(true));
          const encryptedAccountNumber = encryptData(formData.accountNumber);
          const modifiedFormData = {
            ...formData,
            accountNumber: encryptedAccountNumber,
            branchName: findBankName(formData.branchName),
          };
          const response = await updateAccountDetail(modifiedFormData);

          setIsEditMode(false); // Disable editing after submission
          await dispatch(setLoader(false));
          if (response?.data?.status === true) {
            toast.success(response.data.message, {
              position: toast.POSITION.TOP_CENTER,
            });
            // fetchProfileData();
          } else {
            toast.warning(response.data.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        await dispatch(setLoader(false));
      }
      await dispatch(setLoader(false));
      setIsEditMode(false);
    }
  };

  // ****************************************************************************************************

  const handleUpdateProfile = async () => {
    const isServiceNotSelected = services.some((service) => !service.serviceId);
    const isPriceNotProvided = services.some((service) => !service.rate);

    if (isServiceNotSelected && isPriceNotProvided) {
      toast.error(
        "Please select a service and provide a price for each service."
      );
      return;
    } else if (isServiceNotSelected) {
      toast.error("Please select a service for each service.");
      return;
    } else if (isPriceNotProvided) {
      toast.error("Please provide a price for each service.");
      return;
    }

    if (
      providerData.cancellationPolicy === "" ||
      providerData.cancellationPolicy == null
    ) {
      toast.error("Please add cancellation policy !");
      return;
    }

    // Check for duplicate services
    const serviceIds = new Set();
    const duplicateService = services.some((service) => {
      // Check if serviceId is an object or a string
      const serviceId =
        typeof service.serviceId === "object"
          ? service.serviceId._id
          : service.serviceId;
      if (serviceIds.has(serviceId)) {
        return true; // Duplicate service found
      }
      serviceIds.add(serviceId);
      return false;
    });

    if (duplicateService) {
      toast.error("Duplicate services are not allowed.");
      return;
    }

    // Extract image names from URLs
    const extractImageName = (url) => {
      return url ? url.split("/").pop().split("?")[0] : ""; // Get filename from URL
    };

    // Restructure service data with image names extracted
    const restructuredData = services.map((item) => ({
      images: item.images.map((img) => extractImageName(img)), // Extract image name from URL
      _id: item._id,
      serviceId:
        typeof item.serviceId === "string"
          ? item.serviceId
          : item.serviceId?._id,
      rate: item.rate,
    }));
    let badgesToAdd = [];
    badgesToAdd = selectedOptions?.map((badge) => badge.label);

    try {
      await dispatch(setLoader(true));
      const formData = new FormData();
      formData.append("name", providerData.name);
      formData.append("email", providerData.email);
      formData.append("phone", providerData.phone);
      formData.append("bio", providerData.bio);
      formData.append("location", providerData.location);
      formData.append("cancellationPolicy", providerData.cancellationPolicy);
      formData.append("services", JSON.stringify(restructuredData));
      if (Array.isArray(badgesToAdd) && badgesToAdd.length) {
        badgesToAdd.forEach((badge, index) => {
          formData.append(`badges[${index}]`, badge);
        });
      } else {
        formData.append("badges", ""); // Append an empty string to represent an empty array
      }

      if (providerData.profilePic instanceof File) {
        formData.append("profilePic", providerData.profilePic);
      }
      if (childSafetyCertificate instanceof File) {
        formData.append("childSafetyCertificate", childSafetyCertificate);
      }
      if (policeVerificationCertificate instanceof File) {
        formData.append(
          "policeVerificationCertificate",
          policeVerificationCertificate
        );
      }
      const response = await updateProfile(formData);
      handleToggle();
      if (response?.data?.status === true) {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        fetchProfileData();
        props.fetchProfileData();
      } else {
        toast.warning(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
      await dispatch(setLoader(false));
    } catch (error) {
      console.error("Error updating profile:", error);
      await dispatch(setLoader(false));
    }
  };

  const handelDeleteProfile = async () => {
    const deletePayload = {
      userId: user.id, // Ensure user.id exists
    };

    const logOutPayload = {
      deviceId: "deedid", // Replace with the actual deviceId dynamically if needed
    };

    try {
      // Show loader
      dispatch(setLoader(true));

      // Step 1: Attempt to Delete the User Profile
      const deleteResponse = await deleteProfileById(deletePayload);

      // Check if the deletion was successful
      if (deleteResponse?.status === 200) {
        // Step 2: Log Out the User
        await logOut(logOutPayload);

        // Clear local storage and Redux state
        localStorage.removeItem("accessToken");
        dispatch(clearUserLocation());
        dispatch(logout());

        // Step 3: Redirect and Show Success Notification
        setConfirmDeleteProfile(false);
        navigate("/?registerModal=true");
        toast.success(
          deleteResponse.data.message || "Profile deleted successfully!",
          toast_success
        );
      } else {
        console.error("Failed to delete profile:", deleteResponse.data.message);
        toast.error(deleteResponse.data.message || "Failed to delete profile.");
      }
    } catch (error) {
      console.error("Error in handelDeleteProfile:", error);

      // Show a user-friendly error message
      toast.error(
        error.response?.data?.message ||
          "An unexpected error occurred. Please try again."
      );
    } finally {
      // Hide loader regardless of outcome
      dispatch(setLoader(false));
    }
  };

  const handleUpdateProfileimg = async (updatedServices) => {
    const restructuredData = updatedServices.map((item) => ({
      images: item.images.map((image) =>
        image.includes("https://")
          ? image.split("/").pop().split("?")[0]
          : image
      ), // Extract filenames from URLs
      _id: item._id,
      serviceId:
        toString.call(item.serviceId) === "[object String]"
          ? item?.serviceId
          : item?.serviceId?._id,
      rate: item.rate,
    }));

    try {
      const formData = new FormData();
      formData.append("name", providerData.name);
      formData.append("email", providerData.email);
      formData.append("phone", providerData.phone);
      formData.append("bio", providerData.bio);
      formData.append("location", providerData.location);
      formData.append("cancellationPolicy", providerData.cancellationPolicy);
      formData.append("services", JSON.stringify(restructuredData));

      if (providerData.profilePic instanceof File) {
        formData.append("profilePic", providerData.profilePic);
      }
      const response = await updateProfile(formData);
      if (response?.data?.status === true) {
        setResetImages(true);
      }

      fetchProfileData();
      props.fetchProfileData();
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleImagesReset = () => {
    setResetImages(false); // Reset resetImages back to false
  };

  const handleSwitchChangeNotification = async (switchType) => {
    const payloadtosend = { ...notificationSettings };
    setNotificationSettings((prevSettings) => ({
      ...prevSettings,
      [switchType]: !prevSettings[switchType],
    }));
    payloadtosend[switchType] = !payloadtosend[switchType];

    await updateNotificationSettingsProvider(payloadtosend);
  };

  const handleJobBuffer = async (bufferTime) => {
    try {
      await dispatch(setLoader(true));

      const payloadToSend = {
        personId: user.id,
        jobBufferHour: bufferTime,
      };

      const response = await updateJobBufferSettings(payloadToSend);
      if (response?.status === 200) {
        await fetchProfileData();
      }

      // Stop loader after operations
      await dispatch(setLoader(false));
    } catch (error) {
      // Handle any errors
      console.error("Error updating job buffer settings:", error);
      await dispatch(setLoader(false)); // Ensure loader is stopped in case of error
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSendLink = async () => {
    await dispatch(setLoader(true));
    const response = await sendReferralEmail({ email: email });

    if (response?.data?.status === true) {
      setEmail("");
      await dispatch(setLoader(false));
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      await dispatch(setLoader(false));
      toast.warning(response.data.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;

    setChangePassword((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditPassword = () => {
    setEditMode(true);
  };

  const handleUpdatePassword = async () => {
    try {
      const response = await ChangePassword(changePassword);
      if (response?.data?.status === true) {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setResetKey((prevKey) => prevKey + 1);
        setEditMode(false);
      } else {
        toast.warning(response.response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (e) {
      console.error(e, "catch");
    }
  };

  const handleEditMarketingEmail = () => {
    setEditMarketing(true);
  };

  const handleUpdateMarketingEmail = async () => {
    // Simulate validation
    if (!validateEmail(marketingEmail)) {
      setEmailError("Invalid email address");
    } else {
      setEmailError("");
      // Handle update logic here, e.g., API call

      let payload = { marketingEmail: marketingEmail };
      let result = await UpdateMarketingEmail(payload);
      if (result.status === 200) {
        toast.success(result.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setEditMarketing(false);
        // setMarketingEmail(result.data.marketingEmail); // Reset the field after updating
        fetchProfileData();
        props.fetchProfileData();
      } else {
        toast.success(result.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        fetchProfileData();
        props.fetchProfileData();
      }
    }
  };

  const handleMarketingEmailChange = (e) => {
    setMarketingEmail(e.target.value);
    // Clear the email error when the user starts typing again
    setEmailError("");
  };

  const validateEmail = (email) => {
    // Basic email validation
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleRadioChange = (event) => {
    let updatedPolicy = "";

    if (event.target.value === "48") {
      updatedPolicy = "Cancel before 48 hours at no charge (Strict)";
    } else if (event.target.value === "12") {
      updatedPolicy = "Cancel before 12 hours at no charge (Moderate)";
    } else {
      updatedPolicy =
        "Cancel anytime before the job has started at no charge (Flexible)";
    }

    setProviderData((previousData) => ({
      ...previousData,
      policy: updatedPolicy,
      cancellationPolicy: event.target.value,
    }));
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    // Add your validation logic here
    if (!formData.accountNumber || formData.accountNumber.trim() === "") {
      newErrors.accountNumber = "Account number  is required";
      valid = false;
    }

    if (
      !formData.accountHolderName ||
      formData.accountHolderName.trim() === ""
    ) {
      newErrors.accountHolderName = "Account holder name is required";
      valid = false;
    }

    // if (!formData.ifscCode || formData.ifscCode.trim() === "") {
    //   newErrors.ifscCode = "ifscCode  is required";
    //   valid = false;
    // }

    if (!formData.branchName || formData.branchName.trim() === "") {
      newErrors.branchName = "Branch name is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleChildSafetyCertificateChange = (event) => {
    const file = event.target.files[0];
    setChildSafetyCertificate(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // Update the state of providerData.childSafetyCertificate
        setProviderData((prevProviderData) => ({
          ...prevProviderData,
          childSafetyCertificate: e.target.result, // Assuming you want to store the image data URL
        }));
        setPreviewUrl(e.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewUrl(null);
    }
  };

  const handlePoliceVerificationCertificateChange = (event) => {
    const file = event.target.files[0];
    setPoliceVerificationCertificate(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setPoliceVerificationPreview(e.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      setPoliceVerificationPreview(null);
    }
  };

  return (
    <>
      <div className="account-setting-wrap">
        <div className="box-wrapper">
          <div className="account-wrapper">
            <div className="provider-setting-wrap">
              <div className="provider-wrapper" id="account-setting">
                <div className="provider-info-wrap">
                  <ToggleButtonGroup
                    value={alignment}
                    exclusive
                    onChange={handleAlignment}
                    aria-label="text alignment"
                  >
                    <ToggleButton value="provider" aria-label="left aligned">
                      Provider
                    </ToggleButton>
                    <ToggleButton value="user" aria-label="centered">
                      User
                    </ToggleButton>
                  </ToggleButtonGroup>

                  <div className="provider-info-title">
                    Account
                    <div className="availability-row">
                      <div className="availability">
                        <i>
                          <UserIcon />
                        </i>{" "}
                        <span>Availability</span>
                      </div>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        checked={availability}
                        // onChange={handleSwitchChange}
                        onChange={(e) => {
                          handleSwitchChange(e.target.checked);
                        }}
                      />
                    </div>
                  </div>
                  <div className="user-provider-detail-top">
                    <div className="user-img-wrap">
                      <div className="user-pic">
                        <img
                          src={image1 || providerData?.profilePic}
                          alt="Profile"
                        />
                      </div>
                      {isToggled ? (
                        <div></div>
                      ) : (
                        <div>
                          <label htmlFor="fileInput" className="edit-pic">
                            <EditIcon />
                          </label>
                          <input
                            id="fileInput"
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                        </div>
                      )}
                    </div>
                    <div className="user-name-wrap">
                      <div className="username">
                        {getFullName(
                          providerData?.firstName,
                          providerData?.lastName
                        )}
                      </div>
                      <div className="user-rating-wrap">
                        <div className="rating">
                          {proRating !== null && proRating !== undefined && (
                            <StarRating rating={proRating} />
                          )}
                        </div>
                        <div className="view-rating">
                          (
                          {providerData?.ratingProvider
                            ? providerData?.ratingProvider
                            : 0}
                          ) -{" "}
                          <span
                            onClick={() => navigate("/provider/viewrating")}
                          >
                            View Ratings
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="edit-btn-wrap">
                      {isToggled ? (
                        <Button
                          variant="outline-primary"
                          onClick={handleToggle}
                        >
                          <EditIcon />
                          Edit Profile
                        </Button>
                      ) : (
                        <Button variant="primary" onClick={handleUpdateProfile}>
                          <EditIcon />
                          Update Profile
                        </Button>
                      )}
                    </div>
                    <div className="delete-btn-wrap">
                      <Button
                        variant="outline-primary"
                        onClick={() => {
                          setConfirmDeleteProfile(true);
                        }}
                      >
                        <DeleteIcon />
                        Delete Profile
                      </Button>
                    </div>
                  </div>
                  <Form className="update-profile">
                    <Row>
                      <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <UserIcon />
                          </div>
                          <Form.Group className="mb-3" controlId="email">
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Full Name"
                              name="name"
                              disabled={isToggled}
                              value={providerData?.name}
                              onChange={handleFormChange}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <EmailIcon />
                          </div>
                          <Form.Group className="mb-3" controlId="email">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Email address"
                              name="email"
                              disabled={true}
                              value={providerData?.email}
                              onChange={handleFormChange}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <CallIcon />
                          </div>
                          <Form.Group className="mb-3" controlId="phone">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Phone Number"
                              name="phone"
                              disabled={isToggled}
                              value={providerData?.phone}
                              onChange={handleFormChange}
                            />
                          </Form.Group>
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="input-wrap">
                          <div className="icon-wrap">
                            <UserIcon />
                          </div>
                          <Form.Group className="mb-3" controlId="bio">
                            <Form.Label>Bio</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              name="bio"
                              disabled={isToggled}
                              value={providerData.bio}
                              onChange={handleFormChange}
                            />
                          </Form.Group>
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="input-wrap canclelation">
                          <div className="icon-wrap">
                            <LocationIcon />
                          </div>

                          <Form.Group className="mb-3" controlId="location">
                            <Form.Label>Location</Form.Label>
                            {isLoaded ? (
                              <Autocomplete
                                onLoad={(ref) =>
                                  (autocompleteRef.current = ref)
                                }
                                onPlaceChanged={handlePlaceChanged}
                                options={{
                                  componentRestrictions: { country: "BM" },
                                }} // Restrict to Bermuda
                              >
                                <Form.Control
                                  type="text"
                                  name="location"
                                  placeholder="Enter location"
                                  disabled={isToggled}
                                  value={providerData?.location || ""}
                                  onChange={(e) =>
                                    setProviderData((prev) => ({
                                      ...prev,
                                      location: e.target.value,
                                    }))
                                  }
                                />
                              </Autocomplete>
                            ) : null}
                          </Form.Group>
                        </div>
                      </Col>

                      {services?.map((service, index) => (
                        <div key={index} className="add-service-container">
                          <div className="add-row-wrap">
                            <div className="add-content">
                              <Row>
                                <Col sm={6}>
                                  <div className="input-wrap">
                                    <div className="icon-wrap">
                                      <ServicesIcon />
                                    </div>
                                    <Form.Label>Add Services</Form.Label>
                                    <Form.Select
                                      className="mb-3"
                                      value={service?.serviceId?._id}
                                      disabled={isToggled}
                                      name={service?.serviceId?.name}
                                      onChange={(e) =>
                                        handleServiceChange(
                                          index,
                                          "serviceId",
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="" disabled selected>
                                        Select Service
                                      </option>
                                      {serviceName?.map((item) => (
                                        <option
                                          key={item?.name}
                                          value={item?._id}
                                        >
                                          {item?.name}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="input-wrap">
                                    <div className="icon-wrap">
                                      <DollorIcon />
                                    </div>
                                    <Form.Group>
                                      <Form.Label>Hourly Rate</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="rate"
                                        placeholder="Hourly Rate"
                                        value={service?.rate}
                                        onChange={(e) =>
                                          handleServiceChange(
                                            index,
                                            "rate",
                                            e.target.value
                                          )
                                        }
                                        disabled={isToggled}
                                      />
                                    </Form.Group>
                                  </div>
                                </Col>
                                <Row>
                                  {!service?.serviceId && (
                                    <Col sm={6}>
                                      <span className="error-message">
                                        Please select a service.
                                      </span>
                                    </Col>
                                  )}
                                  {(!service?.rate || isNaN(service?.rate)) && (
                                    <Col sm={6}>
                                      <span className="error-message">
                                        Please provide a valid price (numbers
                                        only).
                                      </span>
                                    </Col>
                                  )}
                                </Row>
                              </Row>
                              <div className="service-images">
                                <div className="uploaded-images">
                                  {service?.images?.map((image, imgIndex) => (
                                    <div
                                      key={imgIndex}
                                      className="image-container"
                                    >
                                      <img
                                        src={image}
                                        alt={`Service ${index + 1} Image ${
                                          imgIndex + 1
                                        }`}
                                        className="service-image"
                                        style={{
                                          maxWidth: "100px",
                                          maxHeight: "100px",
                                        }}
                                      />
                                      {!isToggled && (
                                        <div
                                          className="delete-icon"
                                          onClick={() =>
                                            removeImg(image, index)
                                          }
                                        >
                                          <DeleteIcon />
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>

                                <div className="added-images">
                                  {!isToggled && (
                                    <ImageUpload
                                      maxImages={5 - service?.images?.length}
                                      index={index}
                                      handleServiceImages={handleServiceImages}
                                      resetImages={resetImages}
                                      handleImagesReset={handleImagesReset}
                                    />
                                  )}
                                </div>
                              </div>
                              <Row className="justify-content-between">
                                <Col sm={3} className="ms-auto upload-btn">
                                  {!isToggled && (
                                    <span
                                      className="image-upload-label"
                                      onClick={() =>
                                        submitServiceImg(index, service)
                                      }
                                    >
                                      Upload Images
                                    </span>
                                  )}
                                </Col>
                              </Row>
                              <br />
                            </div>
                            {!isToggled && (
                              <div
                                className="delete-icon"
                                onClick={() =>
                                  handleDeleteServiceConfirm(
                                    index,
                                    service?._id
                                  )
                                }
                              >
                                <DeleteIcon />
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                      {!isToggled && (
                        <Col md={12} className="mb-4 mt-2">
                          <span
                            className="add-service-link"
                            onClick={handleAddService} // Assuming images are empty initially
                          >
                            + Add more services
                          </span>
                        </Col>
                      )}
                      {isToggled ? (
                        <Col lg={12}>
                          <div className="input-wrap canclelation">
                            <div className="icon-wrap">
                              <SheildIcon />
                            </div>
                            <Form.Group className="mb-3" controlId="location">
                              <Form.Control
                                type="text"
                                placeholder="Cancellation Policy"
                                disabled={isToggled}
                                value={providerData?.policyText}
                              />
                            </Form.Group>
                          </div>
                        </Col>
                      ) : (
                        <Col md={12}>
                          <div className="box-wrapper">
                            <div className="input-wrap">
                              <div className="icon-wrap">
                                <SheildIcon />
                              </div>
                              <label className="form-label">
                                Cancelation Policy
                              </label>
                              <div className="form-control">
                                <Form.Check
                                  type="radio"
                                  label="Cancel before 48 at no charge"
                                  value="48"
                                  name="radioGroup"
                                  id="option1"
                                  checked={
                                    providerData?.policy ===
                                    "Cancel before 48 hours at no charge (Strict)"
                                  }
                                  onMouseUp={handleRadioChange}
                                />
                                <Form.Check
                                  type="radio"
                                  label="Cancel before 12 at no charge"
                                  value="12"
                                  name="radioGroup"
                                  id="option2"
                                  checked={
                                    providerData?.policy ===
                                    "Cancel before 12 hours at no charge (Moderate)"
                                  }
                                  onMouseUp={handleRadioChange}
                                />
                                <Form.Check
                                  type="radio"
                                  label="Cancel anytime at no charge"
                                  value="0"
                                  name="radioGroup"
                                  id="option3"
                                  checked={
                                    providerData?.policy ===
                                    "Cancel anytime before the job has started at no charge (Flexible)"
                                  }
                                  onMouseUp={handleRadioChange}
                                />
                              </div>
                            </div>
                            <div></div>
                          </div>
                        </Col>
                      )}

                      <div>
                        <h6
                          className="title-badge"
                          style={{ color: "#7F29D6" }}
                        >
                          About Badges :
                        </h6>
                        <p
                          className="badge-description"
                          style={{ color: "#7F29D6" }}
                        >
                          The professional badges will be displayed on your
                          profile to the customer and will provide background
                          into professional qualifications, certifications and
                          disclosures. You will need to upload the required
                          documentation for approval to add any specific
                          qualifications, certifications shared on your profile.
                        </p>
                      </div>

                      {isToggled ? (
                        <div
                          className="account-info-wrap"
                          id="manage-badges" /* ref={passwordRef} */
                        >
                          <Container className="border rounded p-4">
                            <h5 className="text-left mb-4 font-weight-bold">
                              Badges
                            </h5>
                            <div className="chips-display">
                              {badges?.length
                                ? badges?.map((data) => {
                                    let icon;

                                    if (data.label === "React") {
                                      icon = <InfoIcon />;
                                    }

                                    return (
                                      <div
                                        className="chips-badges"
                                        key={data.key}
                                      >
                                        <Chip
                                          avatar={
                                            <Avatar
                                              alt="Natacha"
                                              src={data.avatarSrc}
                                            />
                                          }
                                          label={data.label}
                                          color="primary"
                                          style={{ backgroundColor: "#7F29D6" }}
                                          size="large"
                                        />
                                      </div>
                                    );
                                  })
                                : "No Badges Added"}
                            </div>
                          </Container>
                        </div>
                      ) : (
                        <Col md={12}>
                          <div className="box-wrapper mt-4">
                            <div className="input-wrap">
                              <div className="icon-wrap">
                                <SheildIcon />
                              </div>
                              <label className="form-label">Badges edit</label>
                              <div className="form-control">
                                <MuiAutocomplete
                                  multiple
                                  sx={{
                                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                                      { borderColor: "#7F29D6" },
                                    p: "20px",
                                  }}
                                  id="tags-outlined"
                                  options={chipData}
                                  getOptionLabel={(option) => option.label}
                                  getOptionSelected={(option, value) =>
                                    option.key === value.key
                                  }
                                  renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                      <Chip
                                        key={index}
                                        avatar={
                                          <Avatar src={option.avatarSrc} />
                                        }
                                        label={option.label}
                                        color="default"
                                        {...getTagProps({ index })}
                                      />
                                    ))
                                  }
                                  onChange={handleChange}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      // label="Select Tags"
                                      placeholder="Select Badges"
                                    />
                                  )}
                                  value={selectedOptions}
                                />
                              </div>
                            </div>
                            <div></div>
                          </div>
                        </Col>
                      )}

                      <Col md={12} className="mt-4">
                        <div className="box-wrapper">
                          <div className="input-wrap">
                            <div className="icon-wrap">
                              <SheildIcon />
                            </div>

                            <label className="form-label">
                              Select Child Safety Certificate
                            </label>

                            <div className="form-control">
                              <div className="image-container">
                                <img
                                  src={
                                    previewUrl ||
                                    image1 ||
                                    providerData?.childSafetyCertificate
                                  }
                                  alt="Child Safety Certificate"
                                  className="certificate-image"
                                />
                              </div>

                              <input
                                type="file"
                                id="childSafetyCertificate"
                                name="childSafetyCertificate"
                                accept="image/*"
                                onChange={handleChildSafetyCertificateChange}
                                disabled={isToggled}
                              />
                            </div>
                          </div>
                        </div>
                      </Col>

                      <Col md={12} className="mt-4">
                        <div className="box-wrapper">
                          <div className="input-wrap">
                            <div className="icon-wrap">
                              <SheildIcon />
                            </div>

                            <label className="form-label">
                              Select Police Verification Certificate
                            </label>

                            <div className="form-control">
                              <div className="image-container">
                                <img
                                  src={
                                    policeVerificationPreview ||
                                    image1 ||
                                    providerData?.policeVerificationCertificate
                                  }
                                  alt="Police Verification Certificate"
                                  className="certificate-image"
                                />
                              </div>
                              <input
                                type="file"
                                id="policeVeficationCertificate"
                                name="policeVeficationCertificate"
                                disabled={isToggled}
                                accept="image/*"
                                onChange={
                                  handlePoliceVerificationCertificateChange
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            </div>

            {/*********************** */}
            {marketingEmail !== null ? (
              <div className="account-info-wrap" id="marketing-email">
                <div className="account-info-title">
                  Marketing Email
                  <div className="edit-btn-wrap">
                    <Button
                      variant={editMarketing ? "primary" : "outline-primary"}
                      onClick={
                        editMarketing
                          ? handleUpdateMarketingEmail
                          : handleEditMarketingEmail
                      }
                    >
                      {editMarketing ? (
                        "Update Marketing Email"
                      ) : (
                        <>
                          <i>
                            <EditIcon />
                          </i>{" "}
                          <span>Edit Marketing Email</span>
                        </>
                      )}
                    </Button>
                  </div>
                </div>
                <Row>
                  <Col md={6}>
                    <div className="input-wrap">
                      <div className="icon-wrap">
                        <EmailIcon />
                      </div>
                      <Form.Group className="mb-2" controlId="marketingEmail">
                        <Form.Label>Marketing Email</Form.Label>
                        <Form.Control
                          type="text"
                          value={marketingEmail}
                          onChange={handleMarketingEmailChange}
                          disabled={!editMarketing}
                        />
                        {emailError && (
                          <div className="text-danger">{emailError}</div>
                        )}
                      </Form.Group>
                    </div>
                  </Col>
                </Row>
              </div>
            ) : null}

            {/* **********************************************************************************************   */}
            <div
              className="account-info-wrap"
              id="password" /* ref={passwordRef} */
            >
              <div className="account-info-title">
                Password
                <div className="edit-btn-wrap">
                  {editMode ? (
                    <Button variant="primary" onClick={handleUpdatePassword}>
                      Update Password
                    </Button>
                  ) : (
                    <Button
                      variant="outline-primary"
                      onClick={handleEditPassword}
                    >
                      <i>
                        <EditIcon />
                      </i>{" "}
                      <span>Edit Password</span>
                    </Button>
                  )}
                </div>
              </div>

              {editMode ? (
                <Row>
                  <Col md={6}>
                    <div className="input-wrap">
                      <div className="icon-wrap">
                        <PasswordIcon />
                      </div>
                      <Form.Group className="mb-2" controlId="password">
                        <Form.Label>Old Password</Form.Label>
                        <Form.Control
                          type="Password"
                          name="currentPassword"
                          placeholder="Change Password"
                          onChange={handlePasswordChange}
                          autoComplete="currentPassword"
                          key={resetKey}
                        />
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="input-wrap">
                      <div className="icon-wrap">
                        <PasswordIcon />
                      </div>
                      <Form.Group className="mb-2" controlId="password">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                          type="Password"
                          name="newPassword"
                          placeholder="Change Password"
                          onChange={handlePasswordChange}
                          key={resetKey}
                        />
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="input-wrap">
                      <div className="icon-wrap">
                        <PasswordIcon />
                      </div>
                      <Form.Group className="mb-2" controlId="password">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                          type="Password"
                          name="confirmNewPassword"
                          placeholder="Change Password"
                          onChange={handlePasswordChange}
                          key={resetKey}
                        />
                      </Form.Group>
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col md={12}>
                    <div className="input-wrap">
                      <div className="icon-wrap">
                        <PasswordIcon />
                      </div>
                      <Form.Group className="mb-2" controlId="password">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Password"
                          disabled
                        />
                      </Form.Group>
                    </div>
                  </Col>
                </Row>
              )}
            </div>

            {/* **********************************************************************************************   */}
            <div
              className="account-info-wrap"
              id="manage-payment" /* ref={passwordRef} */
            >
              <div className="account-info-title">Add your bank details</div>

              <Container className="border rounded p-4">
                <Row>
                  <Col md={6}>
                    <div className="input-wrap">
                      <Form.Group className="mb-4" controlId="password">
                        <Form.Label>Account Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Account Number"
                          name="accountNumber"
                          onChange={handleInputChange}
                          value={formData.accountNumber}
                          disabled={!isEditMode}
                        />
                        {errors.accountNumber && (
                          <span style={{ color: "red" }}>
                            {errors.accountNumber}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="input-wrap">
                      <Form.Group className="mb-2" controlId="password">
                        <Form.Label>Account Holder Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Account Holder Name"
                          name="accountHolderName"
                          onChange={handleInputChange}
                          value={formData.accountHolderName}
                          disabled={!isEditMode}
                        />
                        {errors.accountHolderName && (
                          <span style={{ color: "red" }}>
                            {errors.accountHolderName}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="input-wrap">
                      <Form.Group className="mb-2" controlId="password">
                        <Form.Label>Bank</Form.Label>
                        <Form.Select
                          className="mb-3"
                          value={formData.branchName}
                          disabled={!isEditMode}
                          onChange={handleInputChange}
                          name="branchName"
                        >
                          <option value="" disabled>
                            Select Bank
                          </option>
                          {banks?.map((bank) => (
                            <option key={bank.value} value={bank.value}>
                              {bank.name}
                            </option>
                          ))}
                          {errors.branchName && (
                            <span style={{ color: "red" }}>
                              {errors.branchName}
                            </span>
                          )}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </Col>
                </Row>

                <div className="account-info-title">
                  <div className="edit-btn-wrap">
                    {!formData.bankTableID ? (
                      <Button variant="primary" onClick={handleSubmit}>
                        Submit
                      </Button>
                    ) : (
                      <Button variant="primary" onClick={managEedit}>
                        {isEditMode ? "Update" : "Edit"}
                      </Button>
                    )}
                  </div>
                </div>
                {/* </Form> */}
              </Container>
            </div>

            {/* **********************************************************************************************   */}
            <div className="account-info-wrap" id="notifications">
              <div className="account-info-title">Buffer between jobs</div>

              <div className="notification-setting-wrapper">
                {/* 1 Hour Job Buffer */}
                <div className="notification-setting-row">
                  <div className="notification-setting-left">
                    <div className="notification-setting-title">1 Hour </div>
                  </div>
                  <div className="notification-setting-right">
                    <Form.Check
                      type="switch"
                      id="oneHourJobBufferSwitch"
                      checked={BufferHour === "01:00"}
                      onChange={() => handleJobBuffer("01:00")}
                    />
                  </div>
                </div>

                {/* 30 Minute Job Buffer */}
                <div className="notification-setting-row">
                  <div className="notification-setting-left">
                    <div className="notification-setting-title">30 Minutes</div>
                  </div>
                  <div className="notification-setting-right">
                    <Form.Check
                      type="switch"
                      id="thirtyMinuteJobBufferSwitch"
                      checked={BufferHour === "00:30"}
                      onChange={() => handleJobBuffer("00:30")}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* **********************************************************************************************   */}
            <div
              className="account-info-wrap"
              id="manage-schedule" /* ref={passwordRef} */
            >
              <div className="account-info-title">Manage Your Schedule</div>

              <Container className="border rounded p-4">
                <h5 className="text-left mb-4 font-weight-bold">
                  Update Schedule
                </h5>
                <Row>
                  {days.map((day, index) => (
                    <div key={index}>
                      <Form.Check
                        type="checkbox"
                        label={
                          [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday",
                          ][day.dayOfWeek]
                        }
                        checked={day.available}
                        onChange={() => handleToggleDay(index)}
                      />
                      {day.available && (
                        <Row>
                          <Col sm={4}>
                            {/* Start Time Picker */}
                            <div className="input-wrap1">
                              <div className="icon-wrap1">
                                <ClockIcon />
                              </div>
                              <Form.Group className="mb-3">
                                <Form.Label>Start Time</Form.Label>
                                <ReactDatePicker
                                  selected={day.startTime}
                                  onChange={(date) =>
                                    handleTimeChange(date, index, "startTime")
                                  }
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={60}
                                  dateFormat="h:mm aa"
                                  timeCaption="Time"
                                  // showIcon
                                  // icon={ClockIcon}
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          <Col sm={1}></Col>
                          <Col sm={4}>
                            {/* End Time Picker */}
                            <div className="input-wrap1">
                              <div className="icon-wrap1">
                                <ClockIcon />
                              </div>
                              <Form.Group className="mb-3">
                                <Form.Label>End Time</Form.Label>
                                <ReactDatePicker
                                  selected={day.endTime}
                                  onChange={(date) =>
                                    handleTimeChange(date, index, "endTime")
                                  }
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={60}
                                  dateFormat="h:mm aa"
                                  timeCaption="Time"
                                />
                              </Form.Group>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </div>
                  ))}
                </Row>

                <div className="account-info-title">
                  <div className="edit-btn-wrap">
                    <Button variant="primary" onClick={handleScheduleSubmit}>
                      Update
                    </Button>
                  </div>
                </div>
                {/* </Form> */}
              </Container>
            </div>

            {/* ***************************************************************************************************************** */}
            <div className="account-info-wrap" id="refer-friend">
              <div className="account-info-title">Refer a friend</div>
              <div className="refer-wrapper">
                <div className="refer-input-wrap">
                  <div className="input-wrap">
                    <div className="icon-wrap">
                      <EmailIcon />
                    </div>
                    <Form.Group controlId="email">
                      <Form.Control
                        type="email"
                        placeholder="Email address"
                        value={email}
                        onChange={handleEmailChange}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="refer-btn-wrap">
                  <Button
                    variant="outline-primary"
                    onClick={handleSendLink}
                    disabled={!email.trim()} // Disable button if email is empty or contains only whitespaces
                  >
                    Send Refer Link
                  </Button>
                </div>
              </div>
            </div>

            {/* ******************************** Notifications Setting***********************************************************************************                */}
            <div className="account-info-wrap" id="notifications">
              <div className="account-info-title">Notifications Setting</div>

              <div className="notification-setting-wrapper">
                <div className="notification-setting-row">
                  <div className="notification-setting-left">
                    <div className="icon-wrap">
                      <NotificationSettingIcon />
                    </div>
                    <div className="notification-setting-title">
                      {/*   Received Request Notification */}
                      Job Notification
                    </div>
                  </div>
                  <div className="notification-setting-right">
                    <Form.Check
                      type="switch"
                      id="receivedRequestSwitch"
                      checked={notificationSettings?.providerNotificationJob}
                      onChange={() =>
                        handleSwitchChangeNotification(
                          "providerNotificationJob"
                        )
                      }
                    />
                  </div>
                </div>

                <div className="notification-setting-row">
                  <div className="notification-setting-left">
                    <div className="icon-wrap">
                      <NotificationSettingIcon />
                    </div>
                    <div className="notification-setting-title">
                      {/* Message Notification */}
                      Rating Notification
                    </div>
                  </div>
                  <div className="notification-setting-right">
                    <Form.Check
                      type="switch"
                      id="messageSwitch"
                      checked={notificationSettings?.providerNotificationRating}
                      onChange={() =>
                        handleSwitchChangeNotification(
                          "providerNotificationRating"
                        )
                      }
                    />
                  </div>
                </div>

                <div className="notification-setting-row">
                  <div className="notification-setting-left">
                    <div className="icon-wrap">
                      <NotificationSettingIcon />
                    </div>
                    <div className="notification-setting-title">
                      {/*  Remider Notification */}
                      Chat Notification
                    </div>
                  </div>
                  <div className="notification-setting-right">
                    <Form.Check
                      type="switch"
                      id="reminderSwitch"
                      checked={notificationSettings?.providerNotificationChat}
                      onChange={() =>
                        handleSwitchChangeNotification(
                          "providerNotificationChat"
                        )
                      }
                    />
                  </div>
                </div>

                <div className="notification-setting-row">
                  <div className="notification-setting-left">
                    <div className="icon-wrap">
                      <NotificationSettingIcon />
                    </div>
                    <div className="notification-setting-title">
                      {/*  Remider Notification */}
                      Payment Notification
                    </div>
                  </div>
                  <div className="notification-setting-right">
                    <Form.Check
                      type="switch"
                      id="reminderSwitch"
                      checked={
                        notificationSettings?.providerNotificationPayment
                      }
                      onChange={() =>
                        handleSwitchChangeNotification(
                          "providerNotificationPayment"
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {confirmStatus ? (
        <ConfirmModal
          isConfirm={confirmStatus}
          text="You want to delete this service"
          handleClose={handleConfirm}
        />
      ) : null}
      {confirmDeleteProfile ? (
        <DeleteModal
          isConfirm={handelDeleteProfile}
          text="Are you sure you want to delete your profile? This action cannot be undone, and all associated data will be permanently removed."
          handleClose={setConfirmDeleteProfile}
        />
      ) : null}
    </>
  );
};

export default AccountSetting;
